import { useQuery } from "@tanstack/react-query";
import { getFestivalEvents } from "@/api/event-about";

/** Upcoming events of any realm held for this festival, as its page lists them. */
export function FestivalEvents({ slug }: { slug: string }) {
  const { data } = useQuery({ queryKey: ["festival-events", slug], queryFn: () => getFestivalEvents(slug) });
  const events = data?.data.events ?? [];
  return (
    <div>
      <p className="text-xs font-medium text-gray-500 mb-1">Events ({events.length})</p>
      <ul className="text-sm text-gray-700 space-y-0.5">
        {events.map((e) => (
          <li key={e.id}>
            {e.title} · {new Date(e.eventDate).toLocaleDateString()} · {e.realm}
          </li>
        ))}
      </ul>
    </div>
  );
}
